export const FOOTNOTE_INDICATOR = '*';

export const AVAILABLE_SPECIALS = 'AVAILABLE_SPECIALS';
export const CONDITIONAL = 'CONDITIONAL';
export const CONDITIONAL_SPECIAL = 'CONDITIONAL_SPECIAL';
export const CONDITIONAL_SPECIAL_DESCRIPTION =
	'CONDITIONAL_SPECIAL_DESCRIPTION';
export const DEALERSHIP = 'DEALERSHIP';
export const MANUFACTURER = 'MANUFACTURER';
export const ONLY_AT = 'ONLY_AT';
export const SEE = 'SEE';



// WEBPACK FOOTER //
// ./src/constants/constants.js